
document.addEventListener("DOMContentLoaded", function () {
  const articleList = document.querySelector("[js-paginate-page]");
  if (!articleList) return;

  // agar load more button hai to hide kar do
  const loadMoreBtn = document.querySelector("[js-load-more-btn]");
  if (loadMoreBtn) loadMoreBtn.style.display = "none";

  // loader element
  const loader = document.querySelector(".blog__loader");

  let nextUrl = articleList.getAttribute("data-next-url");
  let loading = false;

  function loadMore() {
    if (!nextUrl || loading) return;
    loading = true;

    articleList.classList.add("is-loading");
    if (loader) loader.style.display = "block";

    fetch(nextUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newList = doc.querySelector("[js-paginate-page]");
        if (!newList) return;

        const newArticles = Array.from(newList.children);
        newArticles.forEach((article) => articleList.appendChild(article));

        nextUrl = newList.getAttribute("data-next-url");

        const newPageParam = new URL(nextUrl, window.location.origin).searchParams.get("page");
        if (newPageParam) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set("page", newPageParam);
          window.history.replaceState({}, "", newUrl);
        }

        loading = false;
        articleList.classList.remove("is-loading");
        if (loader) loader.style.display = "none";
      })
      .catch(() => {
        loading = false;
        articleList.classList.remove("is-loading");
        if (loader) loader.style.display = "none";
      });
  }

  window.addEventListener("scroll", function () {
    const rect = articleList.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    if (rect.bottom <= windowHeight + 100) {
      loadMore();
    }
  });
});


